import { z } from 'zod';

export const CarteSchema = z.object({
    numero: z.string().regex(/^\d{6}$/, 'Le numéro de carte doit contenir exactement 6 chiffres.'),
    type: z.enum(['Crédit', 'Provision']),
    porteur: z.string().min(1, 'Le porteur est requis.'),
    codeArticle: z.enum(['ES', 'GO']).optional(),
    dateValidite: z.date().default(() => new Date()) || Date,
    dateExtremeValidite:
        z.date().default(() => {
            const date = new Date();
            date.setFullYear(date.getFullYear() + 2);
            return date;
        }) || Date,
    branche: z.string().optional(),
    statut: z.enum(['Actif', 'Inactif']).default('Actif'),
    limitePrise: z.coerce.number().positive('La limite de prise doit être un nombre positif.').nullable().optional(),
    limiteMensuelGo: z.coerce.number().positive('La limite mensuelle GO doit être un nombre positif.').nullable().optional(),
    limiteMensuelEs: z.coerce.number().positive('La limite mensuelle ES doit être un nombre positif.').nullable().optional(),
    rfidCode: z.string().min(1, 'Le code RFID est requis.'),
    codeQr: z.string().min(1, 'Le code QR est requis.'),
    codePin: z.string().regex(/^\d{4}$/, 'Le code PIN doit contenir exactement 4 chiffres.'),
    noLimitUpToMonthLimit: z.string().optional(),
});

export type CarteRow = z.infer<typeof CarteSchema>;
